import { Badge } from "@/_v2/components/ui/badge";

import { FLAG_CATEGORIES, FlagCategory } from "../flag-catalog";

// Full class names so Tailwind's content scanner picks them up
const DOT_COLORS = [
  "bg-brand",
  "bg-info",
  "bg-success",
  "bg-warning",
  "bg-destructive",
  "bg-primary",
] as const;

const dotColorFor = (category: FlagCategory) =>
  DOT_COLORS[FLAG_CATEGORIES.indexOf(category) % DOT_COLORS.length];

export const CategoryBadge = ({
  category,
}: {
  category: FlagCategory | null;
}) => {
  if (!category) {
    return <Badge variant="outline">Undocumented</Badge>;
  }

  return (
    <Badge variant="outline" className="whitespace-nowrap font-normal">
      <span
        className={`mr-1.5 inline-block h-2 w-2 rounded-full ${dotColorFor(category)}`}
      />
      {category}
    </Badge>
  );
};
